import { FEATURE } from '../../feature/shared/feature.enums';
import { LAYER } from '../../layer/shared/layer.enums';

export const SEARCH_TYPES = [FEATURE, LAYER];
